window.setChangeUserControl = function() {
	var objCU;
	objCU = document.getElementById('CurrentUserDropdown');
	if (objCU) {
		for (var i=0;i<objCU.options.length;i++) {
			objCU.options[i].selected = objCU.options[i].defaultSelected;
		}
	}
};

